import config from "../config";
const baseUrl = config.base_url + "container_reproductive_report_template/";

export default {
  listByReproductiveId: {
    url: baseUrl + "listByReproductiveId",
    type: "get",
  },
  getDetail: {
    url: baseUrl + "getDetail",
    type: "get",
  },
  save: {
    url: baseUrl + "save",
    type: "post",
  },
  delete: {
    url: baseUrl + "delete",
    type: "get",
  },
  reorder: {
    url: baseUrl + "reorder",
    type: "post",
  },
};
